


















import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
})
export default class CommunicationTypeActivity extends Vue {
  @Prop({ required: true })
  private item!: any;

  private mounted() {}

  private getFormatDate(date: Date) {
    return moment(date).format("DD/MM/YYYY HH:mm");
  }
}
